import React from "react";
import { Card, Button, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { getConditionSummary, getFieldLabel } from "app/pages/EarlyBirdOfferBuilder/fieldLibrary";
import { EarlyBirdConditionWithUiId } from "app/pages/EarlyBirdOfferBuilder/actionTypes";
import type { BuilderPageLoadedData } from "app/pages/EarlyBirdOfferBuilder/actionTypes";

interface ConditionCardProps {
    condition: EarlyBirdConditionWithUiId;
    lookups?: BuilderPageLoadedData | null;
    onRemove: () => void;
    onEdit: () => void;
}

export const ConditionCard: React.FC<ConditionCardProps> = ({ condition, lookups, onRemove, onEdit }) => {
    const title = getFieldLabel(condition.field);
    const summary = getConditionSummary(condition, lookups);

    const handleRemove = (e: React.MouseEvent) => {
        e.stopPropagation();
        Modal.confirm({
            title: "Remove condition",
            content: `Remove "${title}" from this rule?`,
            okText: "Remove",
            okType: "danger",
            cancelText: "Cancel",
            onOk: onRemove,
        });
    };

    return (
        <Card size="small" style={{ marginBottom: 8 }} onClick={onEdit}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                    <div style={{ fontWeight: 500, marginBottom: 4 }}>{title}</div>
                    <div style={{ fontSize: 12, color: "#666" }}>{summary || "—"}</div>
                </div>
                <Button
                    type="text"
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={handleRemove}
                />
            </div>
        </Card>
    );
}
